
























import { Button, Container, SecondaryButton } from '../atoms'
import { Vue, Component } from 'vue-property-decorator'
import { Liff } from '../organisms'
import { mapGetters } from 'vuex'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'
@Component({
  components: {
    Container,
    Button,
    SecondaryButton,
    Liff
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  }
})
export default class Ineligible extends Vue {
  // Get customer_state query string
  public customer_state = ''
  public contentURL = process.env.VUE_APP_SCONTENT_URL || 'https://scontent.finnomena.com'
  public stateLogo = ''
  public stateConfig = `${this.contentURL}/auth/customer-state/state-config.json`
  public title = []
  public description = []
  public baseURL = process.env.VUE_APP_BASE_URL || 'https://auth.finnomena.com'
  async mounted() {
    try {
      // Example: http://localhost:3000/ineligible?customer_state=ACCOUNT_APPROVED
      if (typeof this.$route?.query?.customer_state == 'string') {
        this.customer_state = this.$route?.query?.customer_state
        this.stateLogo = `${this.contentURL}/auth/customer-state/${this.customer_state}.png`
      }

      const resp = await fetch(`${this.stateConfig}`)
      if (resp.status >= 400) {
        throw new Error(`ไม่สามารถแสดงข้อมูลได้ (status: ${resp.status})`)
      }

      let res = await resp.json()

      for (const value of res) {
        if (this.customer_state == value.state) {
          this.title = value.title
          this.description = value.description
        }
      }
    } catch (err) {
      const e = err as Error
      this.displayError(`ไม่สามารถแสดงข้อมูลได้ (${e.message})`)
    }
  }
  async accept() {
    const baseURL = process.env.VUE_APP_FINNO_PORT_DASHBOARD_ENDPOINT || 'https://port.finnomena.com/dashboard'
    location.href = location.href = baseURL
  }

  displayError(msg: string) {
    location.href = `${this.baseURL}?error=${encodeURIComponent(msg)}`
  }

  displayNewLine(data: string[]) {
    let title = ''
    for (const value of data) {
      title = title + value + '\n'
    }
    return title
  }
}
